function startCountdown(timerElement) {
    let targetYear = timerElement.dataset.year;
    let targetMonth = timerElement.dataset.month - 1; // 月份从0开始
    let targetDay = timerElement.dataset.day;
    let targetHour = timerElement.dataset.hour;
    let targetMinute = timerElement.dataset.minute;

    const moduleType = timerElement.dataset.moduleType || "default";
    const countdownContainer = timerElement.closest('[class*="-block"], .simple_countdown');

    let targetTime = new Date(targetYear, targetMonth, targetDay, targetHour, targetMinute).getTime();

    function formatNumber(num) {
        return num < 10 ? '0' + num : num;
    }

    function updateCountdown() {
        let now = new Date().getTime();
        let distance = targetTime - now;

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const daysEl = timerElement.querySelector("#days span.count");
        const hoursEl = timerElement.querySelector("#hours span.count");
        const minutesEl = timerElement.querySelector("#minutes span.count");
        const secondsEl = timerElement.querySelector("#seconds span.count");

        if (daysEl) daysEl.textContent = formatNumber(days);
        if (hoursEl) hoursEl.textContent = formatNumber(hours);
        if (minutesEl) minutesEl.textContent = formatNumber(minutes);
        if (secondsEl) secondsEl.textContent = formatNumber(seconds);
        
        if (distance < 0) {
            clearInterval(interval);
            if (timerElement.parentElement) {
                timerElement.parentElement.style.display = "none";
            }
            if (countdownContainer) {
                countdownContainer.dispatchEvent(new CustomEvent('countdownEnd', {
                    bubbles: true,
                    cancelable: true,
                    detail: { moduleType: moduleType }
                }));
            }
        } else {
            // 更新屏幕阅读器的内容
            timerElement.setAttribute('aria-valuenow', distance);
        }
    }

    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

function initializeCountdowns() {
    const countdownTimers = document.querySelectorAll(".custom-countdown__timer");
    countdownTimers.forEach(timer => { 
        startCountdown(timer);
    });
}

document.addEventListener("DOMContentLoaded", initializeCountdowns);
